export default {
    styleOverrides: {
        root: ({ theme }) => ({
            zIndex: theme.zIndex.modal,
        }),
        colorDefault: ({ theme }) => ({
            backgroundColor: theme.vars.palette.surface.containerLowest,
            ...theme.applyStyles("dark", {
                boxShadow: "none",
            }),
        }),
    },
};
